import { Offer } from '@shared/types';

export const isOfferDateValid = (offer: Offer): boolean => {
    const now = Date.now() / 1000;
    if (offer.start_at && now < offer.start_at) {
        return false;
    }
    if (offer.end_at && now > offer.end_at) {
        return false;
    }
    return true;
};
